import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Drawer from '../Drawer/Drawer';
import PendingSessions from './PendingSessions';

const SessionsPending = observer(class SessionsPending extends React.Component {
  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      messageThreadSid: null
    }
  }

  render() {
    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <PendingSessions
            parent={this}
            root={true}
            {...this.props}
          />
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          messageSid={this.state.messageThreadSid}
          pending={true}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('SessionsPending')(SessionsPending);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/SessionsPending.js